import { HomeOutlined, AppstoreOutlined } from '@ant-design/icons';
import { TMenuIcon } from '@/typings';

const menuIcon: TMenuIcon = {
  home: <HomeOutlined />,
  other: <AppstoreOutlined />,
};

export default menuIcon;
